/**
 *
 * @param {{signupStage: string, idAdjust: string, idInfluencerLink: number, loginData: object }} payload
 */
export function handleAdjustEventRequest(payload) {
	return {
		type: "@adjust/HANDLE_ADJUST_EVENT",
		payload,
	};
}
